import { apiClient } from "@/api/softphone_api";
import { apiClientJoin } from "@/api/join_api";
import { toastInfo } from "@/modules/shared/helpers/sweetalert2";
import FileSaver from "file-saver";

export const getEntity = async (
  { commit },
  { page, itemsPerPage, mutation1, mutation2, entity, term, users, active }
) => {
  if (page > 0) {
    page = page - 1;
  }
  const activeParam = active !== undefined ? `&active=${active}` : "";
  let url;
  if (term && term.trim().length > 1) {
    url = `/api/crm/${entity}/?search=${term}&limit=${itemsPerPage}&offset=${
      page * itemsPerPage
    }${activeParam}`;
  } else if (users) {
    url = `/api/crm/${entity}/?limit=${itemsPerPage}&offset=${
      page * itemsPerPage
    }&username=${users}${activeParam}`;
  } else {
    url = `/api/crm/${entity}/?limit=${itemsPerPage}&offset=${
      page * itemsPerPage
    }${activeParam}`;
  }

  try {
    const res = await apiClient.get(url);
    console.log(
      "REQUEST URL -> :",
      url,
      "RES.DATA.RESULTS:",
      res.data.results,
      "RES.DATA.count:",
      res.data.count
    );
    console.log("ALL RESPONSE: ", res);
    if (res.data.total_general) {
      console.log("total general =>=>", res.data.total_general);
      commit("setTotalVentas", res.data.total_general);
    }
    if (!res.data.results) {
      console.log("LA DATA NO RESULT ->:", res.data);
      res.data.results = res.data;
    }

    if (mutation1) commit(mutation1, res.data.results);
    if (mutation2) commit(mutation2, res.data.count);

    return res;
  } catch (error) {
    if (error.code == "ERR_NETWORK") {
      toastInfo.fire({
        icon: "error",
        title: "¡Error, revise su conexión a internet!",
      });
    }
  }
};

export const saveEntity = async ({ commit }, params) => {
  const url = `/api/crm/${params.entity}/`;
  const res = await apiClient.post(url, params.data);
  console.log("MI DATA: ", params.data);
  console.log("MI res: ", res, commit);

  return res;
};
export const updateEntity = async ({ commit }, params) => {
  console.log("los params: ", params);
  const url = `/api/crm/${params.entity}/${params.idPerson}/`;
  const res = await apiClient.patch(url, params.data);

  console.log("DATA UPDATE --> : ", params.data);
  if (params.removeLead) {
    commit("removeLead", params.removeLead);
  }
  if (params.update) {
    commit("updateCompany", res.data);
  }
  if (params.updateEvent) {
    commit(params.updateEvent, res.data);
  }
  if (params.updateContact) {
    commit(params.updateContact, res.data);
  }
  // console.log("RESPONSE UPDATE -->: ", res);
  return res;
};
export const search = async ({ commit }, params) => {
  const url = `/api/crm/${params.entity}/?search=${params.term}`;
  const res = await apiClient.get(url);
  console.log(commit, "MI RESPONSE: ", res);
  commit(params.mutation1, res.data.results);
  commit(params.mutation2, res.data.count);
};
export const searchEntity = async ({ commit }, params) => {
  const url = `/api/crm/${params.entity}/?search=${params.term}`;
  const res = await apiClient.get(url);
  console.log(commit, "MI RESPONSE: ", res);
  commit(params.mutation1, res.data.results);
  commit(params.mutation2, res.data.count);
};

export const downloadEntity = async ({ commit }, params) => {
  const url = `/api/crm/${params.entity}/download/`;
  const res = await apiClient.get(url, {
    responseType: "blob",
  });
  FileSaver.saveAs(res.data, `${params.entity}.xlsx`);
  console.log("MI RESPONSE: ", res);
  console.log(commit);
};
export const downloadLead = async (context, params) => {
  const url = `/api/crm/${params.url}`;
  const res = await apiClient.get(url, {
    responseType: "blob",
  });
  FileSaver.saveAs(res.data, `${params.entity}.xlsx`);
  console.log("MI RESPONSE: ", res);
};

export const simpleGetEntity = async (
  { commit },
  { entity, mutation1, mutation2 }
) => {
  const url = `/api/crm/${entity}/`;
  const res = await apiClient.get(url);
  console.log("AQUI VA EL REQUEST: ", res);
  commit(mutation1, res.data.results);
  commit(mutation2, res.data.count);
};

export const getCallRecords = async ({ commit }, dataToFilter) => {
  console.log("Data to filter: ", dataToFilter);
  const res = await apiClient.post(`api/webrtc/calls_app`, dataToFilter);
  console.log("RESPONSE CALL RECORDS API: ", res.data.cdrs);
  commit("setInteractions", res.data.cdrs);
};

export const getPerson = async (context, { id, idInteraccion }) => {
  let url = "";
  if (idInteraccion) {
    url = `/api/crm/persons/${id}/?id_interaction=${idInteraccion}`;
  } else {
    url = `/api/crm/persons/${id}/`;
  }
  const res = await apiClient.get(url);
  console.log(
    "OPTENIENDO PERSONAS --> : ",
    res.data,
    "-- idInteraccion:",
    idInteraccion
  );
  return res.data;
};

export const changeFunnelStage = async ({ commit }, params) => {
  const url = `/api/crm/business_stages/${params.personId}/business/${params.businessName}/`;
  const res = await apiClient.post(url, params.data);
  console.log("FUNNEl STAGE CAMBIADO -->: ", res, "commit: ", commit);
};

export const addComment = async (context, params) => {
  const url = `/api/crm/comments/`;
  const res = await apiClient.post(url, params.data);
  console.log(" *** COMMENT GUARDADO --> : ", res);
  return res;
};
export const editComment = async (context, params) => {
  const url = `/api/crm/comments/${params.data.comentID}/`;
  try {
    const res = await apiClient.put(url, params.data);
    console.log(" *** COMMENT EDITADO --> : ", res);
    return res;
  } catch (error) {
    console.error("Error al editar comentario: ", error);
    throw error;
  }
};

export const addNeeds = async ({ commit }, params) => {
  const url = `/api/crm/needs_persons/${params.personId}/`;
  const res = await apiClient.post(url, params.data);
  console.log("NEEDS GUARDADO -->: ", res, "commit: ", commit);
  return res;
};
export const changeStatus = async ({ commit }, params) => {
  const url = `/api/crm/update-person-status/${params.personId}/`;
  const res = await apiClient.put(url, params.data);
  console.log("ESTADO GUARDADO -->: ", res, "commit: ", commit);
  if (params.mutation1) commit(params.mutation1, params.personId);
  return res;
};

export const VariablesByStatus = async ({ commit }, { status }) => {
  const url = `/api/crm/variables_by_status/${status}/`;
  const res = await apiClient.get(url);
  console.log(commit);
  return res;
};

export const uploadFile = async ({ commit }, params) => {
  var data = new FormData();
  data.append("file", params.file);
  data.append("description", params.description);
  data.append("person_id", `${params.person_id}`);

  console.log("NUEVO ARCHIVO : ", params.file);
  const url = `/api/crm/attachments/`;
  const res = await apiClient.post(url, data);
  console.log(res, params, commit);
};
export const uploadLeads = async ({ commit }, params) => {
  var data = new FormData();
  data.append("file", params.file);

  console.log("NUEVO ARCHIVO : ", params.file);
  const url = `/api/crm/lead_upload_excel/`;
  const res = await apiClient.post(url, data);
  console.log(res, params, commit);
  return res;
};
export const deleteEvent = async ({ commit }, params) => {
  const url = `/api/crm/agenda/${params.id}/`;
  const res = await apiClient.delete(url);
  commit("removeEvent", params.id);
  console.log(res);
};
export const deleteEventRep = async ({ commit }, params) => {
  const url = `/api/crm/agenda/${params.id}/delete_occurrence/`;
  const res = await apiClient.post(url, {
    apply_only_today: params.apply_only_today,
    target_date: params.target_date,
    entity: params.entity,
  });
  commit("removeEvent", params.id);
  return res;
};
export const businessToSale = async ({ commit }, params) => {
  const url = `/api/crm/needs_persons/${params.person_id}/business/${params.businessId}/`;
  const res = await apiClient.put(url, params.data);
  commit("removeState", {
    key: "business",
    keySearch: "business_id",
    value: params.businessId,
  });
  console.log("SALES RESPONSE: ", res, commit);
};

export const getDateFilter = async (
  { commit },
  {
    page,
    itemsPerPage,
    mutation1,
    mutation2,
    entity,
    initDate,
    finishDate,
    users,
    term,
    status,
  }
) => {
  if (page > 0) {
    page = page - 1;
  }
  let url;
  if (term && term.trim().length > 1) {
    url = `/api/crm/${entity}/?statuses=${status}&search=${term}&limit=${itemsPerPage}&offset=${
      page * itemsPerPage
    }&initDate=${initDate}&finishDate=${finishDate}`;
  } else if (users) {
    if (status) {
      url = `/api/crm/${entity}/?statuses=${status}&limit=${itemsPerPage}&offset=${
        page * itemsPerPage
      }&initDate=${initDate}&finishDate=${finishDate}&username=${users}`;
    } else {
      url = `/api/crm/${entity}/?limit=${itemsPerPage}&offset=${
        page * itemsPerPage
      }&initDate=${initDate}&finishDate=${finishDate}&username=${users}`;
    }
  } else {
    url = `/api/crm/${entity}/?statuses=${status}&limit=${itemsPerPage}&offset=${
      page * itemsPerPage
    }&initDate=${initDate}&finishDate=${finishDate}`;
  }

  try {
    const res = await apiClient.get(url);
    console.log("REQUEST URL -> :", url, "RES.DATA.RESULTS:", res.data.results);
    console.log("ALL RESPONSE: ", res);
    if (res.data.total_general) {
      console.log("total general =>=>", res.data.total_general);
      commit("setTotalVentas", res.data.total_general);
    }
    if (!res.data.results) {
      console.log("LA DATA NO RESULT ->:", res.data);
      res.data.results = res.data;
    }
    console.log(url);
    console.log(
      "EL TOTAL COUNT BUSINESS: ",
      res.data.count,
      "MUTATION: ",
      mutation2
    );

    commit(mutation1, res.data.results);
    commit(mutation2, res.data.count);
  } catch (error) {
    if (error.code == "ERR_NETWORK") {
      toastInfo.fire({
        icon: "error",
        title: "¡Error, revise su conexión a internet!",
      });
    }
  }
};
export const downloadBusiness = async (
  { commit },
  { page, itemsPerPage, entity, initDate, finishDate, users, term, status }
) => {
  if (page > 0) {
    page = page - 1;
  }
  let url;
  if (term && term.trim().length > 1) {
    url = `/api/crm/${entity}/?statuses=${status}&search=${term}&limit=${itemsPerPage}&offset=${
      page * itemsPerPage
    }&initDate=${initDate}&finishDate=${finishDate}&download=true`;
  } else if (users) {
    url = `/api/crm/${entity}/?statuses=${status}&limit=${itemsPerPage}&offset=${
      page * itemsPerPage
    }&initDate=${initDate}&finishDate=${finishDate}&username=${users}&download=true`;
  } else {
    url = `/api/crm/${entity}/?statuses=${status}&limit=${itemsPerPage}&offset=${
      page * itemsPerPage
    }&initDate=${initDate}&finishDate=${finishDate}&download=true`;
  }

  try {
    const res = await apiClient.get(url, {
      responseType: "blob",
    });
    FileSaver.saveAs(res.data, `Negocios.xlsx`);
    console.log("MI RESPONSE: ", res);
    console.log(commit);
  } catch (error) {
    if (error.code == "ERR_NETWORK") {
      toastInfo.fire({
        icon: "error",
        title: "¡Error, revise su conexión a internet!",
      });
    }
  }
};

export const getUsers = async ({ commit }) => {
  const url = `/api/crm/users_sipmovil/?limit=10&offset=10&active=true`;
  const res = await apiClient.get(url);
  console.log("MI LISTA DE USUARIOS RESPONSE : ", res);
  commit("setUsers", res.data.results);
};

export const filterByUser = ({ commit }, nuevoUsername) => {
  commit("filterByUser", nuevoUsername);
};

export const callPerson = ({ commit }, number) => {
  commit("softphone_store/INIT_CALL", number, { root: true });
};
export const getEnty = async (context, params) => {
  const url = `/api/crm/${params.enty}/${params.id}/`;
  const res = await apiClient.get(url);
  console.log("LOG DEL REQUES GET ENTY: ", res);
  return res;
};
export const updateBusiness = async (context, params) => {
  const url = `/api/crm/needs_persons/${params.person_id}/business/${params.business_Id}/`;
  const res = await apiClient.put(url, params.data);
  console.log("REPONSE UPDATE: ", res);
  return res;
};

export const getStatuses = async ({ commit }) => {
  const url = `/api/crm/statuses/`;
  const res = await apiClient.get(url);
  console.log("--- STATUSES: ", res.data.results);
  commit("setState", { key: "statusBusiness", value: res.data.results });
};
export const getEvent = async (context, id) => {
  const url = `/api/crm/agenda/${id}/`;
  const res = await apiClient.get(url);
  return res;
};

export const getEntyDefault = async ({ commit }, params) => {
  const url = `/api/crm/${params.url}`;
  const res = await apiClient.get(url);
  console.log(`RESPONSE GET ENTY TO ${url}`, res);
  commit(params.mutation1, { key: params.enty, value: res.data.results });
  if (params.mutation2) {
    commit(params.mutation2, res.data.count);
  }
  if (params.setCount) {
    console.log("la llaveeeeee", params.setCount, params.mutation1);
    commit(params.mutation1, { key: params.setCount, value: res.data.count });
  }
};
export const saveEnty = async ({ commit }, params) => {
  console.log("DATA POST: ", params.data);
  const url = `/api/crm/${params.url}`;
  const res = await apiClient.post(url, params.data);
  console.log(`RESPONSE POST ENTY TO ${url}`, res);
  commit(params.mutation1, { key: params.enty, value: res.data });
};
export const updateEnty = async ({ commit }, params) => {
  console.log("DATA PUT: ", params.data);
  const url = `/api/crm/${params.url}/`;
  const res = await apiClient.patch(url, params.data);
  console.log(`RESPONSE PUT ENTY TO ${url}`, res);
  commit(params.mutation1, {
    key: params.enty,
    keySearch: params.keySearch,
    value: res.data,
  });
  return res;
};
export const deleteEnty = async ({ commit }, params) => {
  // console.log("DATA DELETE: ", params);
  const url = `/api/crm/${params.url}`;
  await apiClient.delete(url);
  // console.log(`RESPONSE POST ENTY TO ${url}`, res);
  commit(params.mutation1, {
    key: params.enty,
    keySearch: params.keySearch,
    value: params.value,
  });
};

export const searchEventByUser = async ({ commit }, params) => {
  const url = `/api/crm/${params.url}`;
  const res = await apiClient.get(url);
  commit("setAgenda", res.data.results);
  // `count` es el total que cumple el filtro de rango, no los que caben en el
  // `limit`. Alimenta el contador de la toolbar de fx-agenda; `agendaCount` y
  // `setCountAgenda` ya existían en el store pero nadie los escribía.
  commit("setCountAgenda", res.data.count ?? res.data.results.length);
};
export const getSenders = async ({ commit }, url) => {
  // console.log("la URLLLLLL: ", url);
  const res = await apiClientJoin.get(url);
  // console.log("LOS SENDERS: ====> ", res);
  commit("setState", { key: "senders", value: res.data.results });
};
export const getDefault = async ({ commit }, params) => {
  const url = `/api/${params.url}`;
  const res = await apiClient.get(url);
  // console.log(`RESPONSE GET ENTY TO ${url}`, res);
  commit(params.mutation1, { key: params.enty, value: res.data.results });
};
export const getCities = async ({ commit }, params) => {
  const url = `/api/${params.url}`;
  const res = await apiClient.get(url);
  // console.log(`RESPONSE GET ENTY TO ${url}`, res);
  commit(params.mutation1, { key: params.enty, value: res.data });
};
export const getAnotationsCommiments = async ({ commit }, idEvent) => {
  const url = `/api/crm/agenda/${idEvent}/commitments-annotations/`;
  try {
    const res = await apiClient.get(url);
    const data = {
      annotation: res.data.annotation || "",
      commitment: res.data.commitment || "",
    };
    const storageKey = `event_${idEvent}_backup`;
    sessionStorage.setItem(storageKey, JSON.stringify(data));
    commit("setAnotationsCommiments", data);
  } catch (error) {
    console.log(error);
    toastInfo.fire({
      icon: "error",
      title: "¡Error al cargar anotaciones y compromisos!",
    });
  }
};
export const saveAnotationsCommiments = async ({ commit }, params) => {
  const url = `/api/crm/agenda/${params.idEvent}/commitments-annotations/`;
  try {
    const { data } = await apiClient.patch(url, params.data);
    console.log("RESPONSE PATCH: ", data.data);
    commit("setAnotationsCommiments", data.data);
  } catch (error) {
    console.log(error);
    toastInfo.fire({
      icon: "error",
      title: "¡Error al cargar anotaciones y compromisos!",
    });
  }
};
export const setShowAnotations = async ({ commit }, showAnotations) => {
  commit("setShowAnotations", showAnotations);
};
export const setEventSelected = async ({ commit }, eventSelected) => {
  commit("setEventSelected", eventSelected);
};
export const cleanAnotationsCommiments = async ({ commit }) => {
  commit("setAnotationsCommiments", null);
};
export const restoreInitialState = async ({ commit }, eventId) => {
  try {
    const storageKey = `event_${eventId}_backup`;
    const storedData = sessionStorage.getItem(storageKey);

    if (storedData) {
      const { annotation, commitment } = JSON.parse(storedData);
      const data = { annotation, commitment };

      // Actualizar la base de datos
      const response = await apiClient.patch(
        `/api/crm/agenda/${eventId}/commitments-annotations/`,
        data
      );

      // Actualizar el estado local
      commit("setAnotationsCommiments", {
        annotation: annotation || "",
        commitment: commitment || "",
      });

      // Limpiar el backup
      sessionStorage.removeItem(storageKey);

      return response.data;
    }
  } catch (error) {
    console.error("Error al restaurar el estado inicial:", error);
    throw error;
  }
};
